import {
    SET_CHANNELS,
    SET_ALL_CHANNELS,
    UPDATE_CHANNEL,
    SET_ARCHIVE_FILTER,
    SET_SHOW_UNLINKED_COUNT,
    SET_CHANNEL_PANEL_OPEN,
    SET_FULLSCREEN_IMAGE,
    SET_CHANNELS_LOADING,
    SET_ACTIVE_THREAD_PARENT_ID
} from '../constants/channel.constant';

// Get initial showUnlinkedCount from localStorage
const getInitialShowUnlinkedCount = () => {
    const saved = localStorage.getItem('showUnlinkedCount');
    return saved !== null ? JSON.parse(saved) : true;
};

const initialState = {
    // Channel data (shared)
    allChannels: [],
    channels: [],

    // UI state
    archiveFilter: 'excludeArchive',
    showUnlinkedCount: getInitialShowUnlinkedCount(),
    channelPanelOpen: false,
    fullscreenImage: null,
    activeThreadParentId: null,

    // Loading state
    isChannelsLoading: false
};

/**
 * Filter channels based on archive filter
 */
const filterChannels = (allChannels, archiveFilter) => {
    const safeChannels = Array.isArray(allChannels) ? allChannels : [];

    switch (archiveFilter) {
        case 'excludeArchive':
            return safeChannels.filter(ch => !ch.is_archived);
        case 'onlyArchive':
            return safeChannels.filter(ch => ch.is_archived);
        case 'includeArchive':
        default:
            return safeChannels;
    }
};

const channelReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALL_CHANNELS:
            const newAllChannels = Array.isArray(action.payload) ? action.payload : [];
            return {
                ...state,
                allChannels: newAllChannels,
                channels: filterChannels(newAllChannels, state.archiveFilter)
            };

        case SET_CHANNELS:
            return {
                ...state,
                channels: Array.isArray(action.payload) ? action.payload : []
            };

        case UPDATE_CHANNEL:
            const { channelId, updates } = action.payload;
            const updatedAllChannels = state.allChannels.map(ch =>
                ch.id === channelId ? { ...ch, ...updates } : ch
            );
            return {
                ...state,
                allChannels: updatedAllChannels,
                channels: filterChannels(updatedAllChannels, state.archiveFilter)
            };

        case SET_ARCHIVE_FILTER:
            return {
                ...state,
                archiveFilter: action.payload,
                channels: filterChannels(state.allChannels, action.payload)
            };

        case SET_SHOW_UNLINKED_COUNT:
            return {
                ...state,
                showUnlinkedCount: action.payload
            };

        case SET_CHANNEL_PANEL_OPEN:
            return {
                ...state,
                channelPanelOpen: action.payload
            };

        case SET_FULLSCREEN_IMAGE:
            return {
                ...state,
                fullscreenImage: action.payload
            };

        case SET_CHANNELS_LOADING:
            return {
                ...state,
                isChannelsLoading: action.payload
            };

        case SET_ACTIVE_THREAD_PARENT_ID:
            return {
                ...state,
                activeThreadParentId: action.payload
            };

        default:
            return state;
    }
};

export default channelReducer;
